import { Capacitor } from '@capacitor/core';

/** Scan is offered wherever the `capture` input opens a camera: the native shells
 *  at any screen size (iPad included), and touch-first browsers — phones and
 *  tablets report a coarse primary pointer. Desktops, touchscreen laptops too
 *  (their primary pointer is the mouse), only get a file picker from that input,
 *  which Upload already covers. */
export const canScanDocuments = () =>
  Capacitor.isNativePlatform() || window.matchMedia('(pointer: coarse)').matches;
